__turbopack_context__.v({
  "chevron": "collapsible-container-module-scss-module__pvlQAW__chevron",
  "chevronCollapsed": "collapsible-container-module-scss-module__pvlQAW__chevronCollapsed",
  "container": "collapsible-container-module-scss-module__pvlQAW__container",
  "content": "collapsible-container-module-scss-module__pvlQAW__content",
  "contentCollapsed": "collapsible-container-module-scss-module__pvlQAW__contentCollapsed",
  "header": "collapsible-container-module-scss-module__pvlQAW__header",
  "heading": "collapsible-container-module-scss-module__pvlQAW__heading",
  "label": "collapsible-container-module-scss-module__pvlQAW__label",
  "title": "collapsible-container-module-scss-module__pvlQAW__title",
  "toggle": "collapsible-container-module-scss-module__pvlQAW__toggle",
});
